import { generate } from '@core/js/utils/componentUtils';
import template from 'category-seo-copy.j2';
import { mDom } from '@core/js/utils/renderUtils';
import { getFlatNavigationSync } from '@core/js/utils/navigationUtils';

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-seo-copy',
        template: template,
        name: 'seoCopyComponent',
        watch: 'category',
        beforeRender: beforeRender,
        renderType: mDom
    };

    return generate(config, store, overrides);
}

export function beforeRender(store) {
    getFlatNavigationSync(store);
}
